import type { RequestProps } from './types';

export async function request({ url, method, body, headers, abortController }: RequestProps) {
  const requestHeaders = { ...headers };
  const response = await fetch(url, {
    method: method || 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...requestHeaders,
    },
    body: body && JSON.stringify(body),
    signal: abortController?.signal,
  });

  // something went wrong
  if (!response.ok) {
    // server probably unable to respond sensibly to our `Accept: 'application/json'` request
    if (response.status > 500) {
      throw new Error('Server was unable to respond. Try again later.');
    }

    const errorResponse = await response.json();
    throw new Error(errorResponse.message || 'Something went wrong.');
  }

  return response;
}
